module.exports = __webpack_public_path__ + "img/ST.3c2b073a.png";